import React from "react";
import { Route, Redirect } from "react-router-dom";
import moment from "moment";
import { store } from "../../_helpers";
import { getConfiguration, getDisciplines } from "../../_services";

// check token expiry
function checkTokenExpiry() {
  // get user in localStorage
  const state = store.getState();
  let user = localStorage.getItem("user");
  if (user) {
    user = JSON.parse(user);
    // set token expiry time to moment and minor 30 mins
    const exp = moment(user.expiresAt).subtract(30, "m");
    // check if token expire time is after now
    const tokenExpired = moment().isAfter(exp);
    if (tokenExpired) {
      console.log("Token expired");
      return false;
    } else {
      // get configuration
      if (Object.keys(state.configuration).length === 0) {
        store.dispatch(getConfiguration(user.token));
      }
      if (Object.keys(state.disciplinesList).length === 0) {
        store.dispatch(getDisciplines(user.token));
      }
      return true;
    }
  } else {
    return false;
  }
}

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      checkTokenExpiry() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);


// WEBPACK FOOTER //
// ./src/_components/PrivateRoute/PrivateRoute.js